import AulaEditor from './AulaEditor.container';

export default AulaEditor;
